import React from 'react';

export function normalizeSearch(value: unknown): string {
    return String(value ?? '').toLocaleLowerCase('hr-HR');
}

export function matchesQuickSearch(values: unknown[], query: string): boolean {
    const needle = normalizeSearch(query).trim();
    if (!needle) {
        return true;
    }

    return values.some((value) => normalizeSearch(value).includes(needle));
}

export function QuickSearchInput({ value, onChange, placeholder = 'Pretraži sve u prikazu…' }: { value: string; onChange: (value: string) => void; placeholder?: string }) {
    return (
        <label className="filter-label quick-search-label">
            Quick search
            <input value={value} placeholder={placeholder} onChange={(event) => onChange(event.target.value)} />
        </label>
    );
}
